import { ConnectionQuality } from 'livekit-client'

import { QualityUnknownIcon, QualityExcellentIcon, QualityGoodIcon, QualityPoorIcon } from './index'

/**
 * @internal
 */
export function getConnectionQualityIcon(quality: ConnectionQuality) {
  switch (quality) {
    case ConnectionQuality.Excellent:
      return <QualityExcellentIcon />
    case ConnectionQuality.Good:
      return <QualityGoodIcon />
    case ConnectionQuality.Poor:
      return <QualityPoorIcon />
    default:
      return <QualityUnknownIcon />
  }
}
